/**
 * Customer photos slider (metaobject-driven).
 *
 * Handles opening the enlarged-photo modal when a slide is clicked, and injects the
 * per-photo info panel (motif name, presented product, related products) from the
 * matching <template> element. The horizontal scrolling of the slider itself is handled
 * entirely by Dawn's built-in <slider-component> (see assets/global.js) - this file only
 * deals with the modal.
 */
if (!customElements.get('customer-photos-slider')) {
  class CustomerPhotosSlider extends HTMLElement {
    connectedCallback() {
      // Guard against being connected more than once (e.g. theme editor re-renders).
      if (this.cpInitialized) return;
      this.cpInitialized = true;

      this.modal = this.dataset.modalId ? document.getElementById(this.dataset.modalId) : null;
      if (!this.modal) return;

      this.modalImage = this.modal.querySelector('[data-cp-modal-image]');
      this.modalInfo = this.modal.querySelector('[data-cp-modal-info]');
      this.modalContent = this.modal.querySelector('.cp-modal__content');
      this.templates = Array.from(this.querySelectorAll('[data-cp-template]'));

      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const trigger = event.target.closest('[data-cp-open]');
      if (!trigger) return;
      this.openPhoto(trigger);
    }

    openPhoto(trigger) {
      const index = trigger.getAttribute('data-cp-index');
      const src = trigger.getAttribute('data-cp-full-src') || '';
      const alt = trigger.getAttribute('data-cp-alt') || '';

      if (this.modalImage) {
        this.modalImage.src = src;
        this.modalImage.alt = alt;
      }

      let hasInfo = false;

      if (this.modalInfo) {
        this.modalInfo.innerHTML = '';
        const template = this.templates.find((el) => el.dataset.cpTemplate === index);
        if (template) {
          this.modalInfo.appendChild(template.content.cloneNode(true));
        }
        // Only the fields that were actually filled in on the metaobject entry get
        // rendered into the template, so an empty result means the photo has no motif,
        // product or related products set - just the image.
        hasInfo = this.modalInfo.children.length > 0;
      }

      if (this.modalContent) {
        this.modalContent.classList.toggle('cp-modal__content--photo-only', !hasInfo);
      }

      if (typeof this.modal.show === 'function') {
        this.modal.show(trigger);
      }
    }
  }

  customElements.define('customer-photos-slider', CustomerPhotosSlider);
}